module.exports = __webpack_public_path__ + "static/media/gp.fa4cab3e.svg";